import {takeWhile, catchError} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone} from '@angular/core';
import {AbstractControlComponent} from './abstract-control';
import {ViewTabComponent} from '../viewtab.component';
import {ErrorService} from '../../../error/error.service';

@Component({
  selector: 'ctrl-data',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CtrlDataComponent extends AbstractControlComponent {
  constructor(
    _parent: ViewTabComponent,
    changeDetector: ChangeDetectorRef,
    _ngZone: NgZone,
    errorService: ErrorService,
  ) {
    super(_parent, null, null, changeDetector, _ngZone, errorService);
  }

  protected initMain(): void {
    super.initMain();
    this._config
      .getBooleanPropertyValues('ForceTargetUpdateOnVisible')
      .pipe(
        catchError((error, caught) => this.handleError(error, caught)),
        takeWhile(() => this.alive),
      )
      .subscribe(forceUpdate => {
        if (forceUpdate === true) {
          this.formControl.updateValueAndValidity({emitEvent: true});
        }
      });
  }

  protected formatSource(source: any): any {
    return source;
  }

  protected formatTarget(value: any): any {
    return value;
  }

  protected initValidators(): void {}
}
